module.exports = "/images/marking-icon-checkbox-unchecked.svg?cd2f21c1bce4ad13a6e4cc08f3c02f11";